import { useEffect, useRef } from 'react'
import { animate, useInView, useReducedMotion } from 'framer-motion'

// A number that counts up on a spring when it scrolls into view. Renders the
// final value immediately for reduced motion and for anything non-numeric.
export default function Counter({ value, className = '', delay = 0 }) {
  const ref = useRef(null)
  const inView = useInView(ref, { once: true, margin: '0px 0px -10% 0px' })
  const reduce = useReducedMotion()
  const numeric = typeof value === 'number' ? value : parseFloat(String(value).replace(/[^\d.]/g, ''))
  const isNumber = Number.isFinite(numeric)

  useEffect(() => {
    const el = ref.current
    if (!el || !isNumber) return
    if (reduce || !inView) {
      if (reduce) el.textContent = String(value)
      return
    }
    const decimals = String(numeric).includes('.') ? String(numeric).split('.')[1].length : 0
    const controls = animate(0, numeric, {
      type: 'spring',
      stiffness: 60,
      damping: 20,
      mass: 1,
      delay,
      onUpdate: (v) => {
        el.textContent = v.toFixed(decimals)
      },
      onComplete: () => {
        el.textContent = String(value)
      },
    })
    return () => controls.stop()
  }, [inView, numeric, isNumber, reduce, value, delay])

  return (
    <span ref={ref} className={`tabular-nums ${className}`}>
      {isNumber && !reduce ? '0' : value}
    </span>
  )
}
